import React from "react"

import type { RawEraUploadCsvRowDTO } from "../../../dto/rawEraUploadCsvRow.dto"
import { EraUploadTableHeaderComponent } from "./eraUploadTableHeader.component"
import { EraUploadTableRowComponent } from "./eraUploadTableRow.component"

export const EraUploadTableComponent: React.FunctionComponent<
    IEraUploadTableComponentProps
> = props => {
    return (
        <div className={`relative w-full ${props.className ?? ""}`}>
            <div
                ref={props.scrollableElementRef}
                className="overflow-x-auto w-full"
            >
                <div className="table w-max min-w-full">
                    <div className="border-b border-solid border-brand-warmLight">
                        <EraUploadTableHeaderComponent />
                    </div>

                    {props.rows.map((row, index) => {
                        return (
                            <EraUploadTableRowComponent
                                key={row.index ?? index}
                                row={row}
                                isLast={index === props.rows.length - 1}
                            />
                        )
                    })}
                </div>
            </div>
        </div>
    )
}

interface IEraUploadTableComponentProps {
    className?: string
    scrollableElementRef?: React.RefObject<HTMLDivElement>
    rows: RawEraUploadCsvRowDTO[]
}
